<template>

    <div>

        <h1 class="mt-4" v-if="company_name == ''"><a href="/companies">Företagskunder</a> / Ny företagskund</h1>
        <h1 class="mt-4" v-if="company_name != ''"><a href="/companies">Företagskunder</a> / {{ company_name }}</h1>

        <div class="summary-container">
            <div class=""></div>
        </div>

        <div class="tabs-container">

            <div class="tab" :class="{ 'active' : activeTab == 'company-info' }" @click="loadView('company-info')">Uppgifter</div>
            <div class="tab" :class="{ 'active' : activeTab == 'workplace-list' }" @click="loadView('workplace-list')">Arbetsplatser</div>
            <div class="tab" :class="{ 'active' : activeTab == 'employee-settings' }" @click="loadView('employee-settings')">Inställningar</div>
            <div class="tab" :class="{ 'active' : activeTab == 'contract' }" @click="loadView('contract')">Avtal</div>
            <div class="tab" :class="{ 'active' : activeTab == 'employee-list' }" @click="loadView('employee-list')">Anställda</div>
            <div class="tab" :class="{ 'active' : activeTab == 'company-accounts' }" @click="loadView('company-accounts')">Företagskonton</div>
            <div class="tab" :class="{ 'active' : activeTab == 'treatments' }" @click="loadView('treatments')">Behandlingar</div>
            <div class="tab" :class="{ 'active' : activeTab == 'costs' }" @click="loadView('costs')">Kostnader</div>
            <div class="tab" :class="{ 'active' : activeTab == 'contact-log' }" @click="loadView('contact-log')">Kontaktlogg</div>

        </div>

        <div class="content-container">

            <transition :name="transitionName" :mode="transitionMode">
                <company-info :company_id="company_id" v-if="activeTab == 'company-info'"></company-info>
                <contact-log :company_id="company_id" v-if="activeTab == 'contact-log'"></contact-log>
                <employee-settings :company_id="company_id" v-if="activeTab == 'employee-settings'"></employee-settings>
                <employee-list :company_id="company_id" v-if="activeTab == 'employee-list'"></employee-list>
                <workplace-list :company_id="company_id" v-if="activeTab == 'workplace-list'"></workplace-list>
                <managers-list :company_id="company_id" v-if="activeTab == 'company-accounts'"></managers-list>
                <billing-list :company_id="company_id" v-if="activeTab == 'costs'"></billing-list>
                <contract :company_id="company_id" v-if="activeTab == 'contract'"></contract>
                <treatments :company_id="company_id" v-if="activeTab == 'treatments'"></treatments>
            </transition>

        </div>

    </div>

</template>

<script>

import companyInfo from './company-info.vue'
import contactLog from './contact-log.vue'
import employeeSettings from './employees-settings.vue'
import employeeList from './employees-list.vue'
import workplaceList from './workplace-list.vue'
import managersList from './managers-list'
import billingList from './billing-list'
import contract from './contract.vue'
import treatments from './treatments-list.vue'

import tabber from '../../../mixins/tabber'

export default {

    components: {
        billingList,
        companyInfo,
        contactLog,
        employeeSettings,
        employeeList,
        workplaceList,
        managersList,
        contract,
        treatments
    },

    mixins: [
        tabber
    ],

    props: {
        company_id: {
            required: true
        },
        company_name: {
            required: true
        }
    },

    data () {
        return {
            defaultTab: 'company-info',
            loading: false,
            transitionName: 'fade',
            transitionMode: 'out-in'
        }
    },

    methods: {

    }

}
</script>
<style type="text/css">

/* --- Fade transition --- */
.fade-enter-active, .fade-leave-active {
    transition: all 350ms;
}
.fade-enter, .fade-leave-to {
    opacity: 0;
}
</style>
